export var CfarOfferType;
(function (CfarOfferType) {
    CfarOfferType["Legacy"] = "Legacy";
    CfarOfferType["Hts"] = "Hts";
})(CfarOfferType || (CfarOfferType = {}));
export var CfarEntryPointVariantEnum;
(function (CfarEntryPointVariantEnum) {
    CfarEntryPointVariantEnum["PostBooking"] = "PostBooking";
    CfarEntryPointVariantEnum["PostBookingFo"] = "PostBookingFo";
})(CfarEntryPointVariantEnum || (CfarEntryPointVariantEnum = {}));
export var FareRefundabilityEnum = {
    FullFtc: "FullFtc",
    NonRefundable: "NonRefundable",
    PartialFtc: "PartialFtc",
};
export var AncillaryOfferEnum;
(function (AncillaryOfferEnum) {
    AncillaryOfferEnum["CfarOffer"] = "CfarOffer";
    AncillaryOfferEnum["ChfarOffer"] = "ChfarOffer";
    AncillaryOfferEnum["DelayOffer"] = "DelayOffer";
    AncillaryOfferEnum["MissedConnectionOffer"] = "MissedConnectionOffer";
})(AncillaryOfferEnum || (AncillaryOfferEnum = {}));
export var AncillaryPostBookingOfferResponseEnum;
(function (AncillaryPostBookingOfferResponseEnum) {
    AncillaryPostBookingOfferResponseEnum["PostBookingOfferNone"] = "PostBookingOfferNone";
    AncillaryPostBookingOfferResponseEnum["PostBookingOfferFound"] = "PostBookingOfferFound";
})(AncillaryPostBookingOfferResponseEnum || (AncillaryPostBookingOfferResponseEnum = {}));
export var AncillaryPostBookingPurchaseResponseEnum;
(function (AncillaryPostBookingPurchaseResponseEnum) {
    AncillaryPostBookingPurchaseResponseEnum["PaymentFailed"] = "PaymentFailed";
    AncillaryPostBookingPurchaseResponseEnum["PurchaseSuccess"] = "PurchaseSuccess";
    AncillaryPostBookingPurchaseResponseEnum["Polling"] = "Polling";
})(AncillaryPostBookingPurchaseResponseEnum || (AncillaryPostBookingPurchaseResponseEnum = {}));
export var AncillaryPostBookingKindEnum;
(function (AncillaryPostBookingKindEnum) {
    AncillaryPostBookingKindEnum["NotCalled"] = "NotCalled";
    AncillaryPostBookingKindEnum["NoOffer"] = "NoOffer";
    AncillaryPostBookingKindEnum["FetchOffer"] = "FetchOffer";
    AncillaryPostBookingKindEnum["ValidOffer"] = "ValidOffer";
    AncillaryPostBookingKindEnum["Confirmation"] = "Confirmation";
})(AncillaryPostBookingKindEnum || (AncillaryPostBookingKindEnum = {}));
export var AncillaryPostBookingPurchaseKindEnum;
(function (AncillaryPostBookingPurchaseKindEnum) {
    AncillaryPostBookingPurchaseKindEnum["NotCalled"] = "NotCalled";
    AncillaryPostBookingPurchaseKindEnum["Failed"] = "Failed";
    AncillaryPostBookingPurchaseKindEnum["InProgress"] = "InProgress";
    AncillaryPostBookingPurchaseKindEnum["Success"] = "Success";
})(AncillaryPostBookingPurchaseKindEnum || (AncillaryPostBookingPurchaseKindEnum = {}));
export var AncillaryFailureEnum;
(function (AncillaryFailureEnum) {
    AncillaryFailureEnum["FareNotFound"] = "FareNotFound";
    AncillaryFailureEnum["TripNotFound"] = "TripNotFound";
    AncillaryFailureEnum["Unknown"] = "Unknown";
})(AncillaryFailureEnum || (AncillaryFailureEnum = {}));
export var AncillaryKindEnum;
(function (AncillaryKindEnum) {
    AncillaryKindEnum["CancelOrChange"] = "CancelOrChange";
    AncillaryKindEnum["Cfar"] = "Cfar";
    AncillaryKindEnum["Chfar"] = "Chfar";
    AncillaryKindEnum["Delay"] = "Delay";
    AncillaryKindEnum["Insurance"] = "Insurance";
    AncillaryKindEnum["Luggage"] = "Luggage";
    AncillaryKindEnum["MissedConnection"] = "MissedConnection";
})(AncillaryKindEnum || (AncillaryKindEnum = {}));
export var AncillaryPostBookingPurchaseStateEnum;
(function (AncillaryPostBookingPurchaseStateEnum) {
    AncillaryPostBookingPurchaseStateEnum["ScheduleQuote"] = "ScheduleQuote";
    AncillaryPostBookingPurchaseStateEnum["PollingQuote"] = "PollingQuote";
    AncillaryPostBookingPurchaseStateEnum["SchedulePurchase"] = "SchedulePurchase";
    AncillaryPostBookingPurchaseStateEnum["PollingPurchase"] = "PollingPurchase";
})(AncillaryPostBookingPurchaseStateEnum || (AncillaryPostBookingPurchaseStateEnum = {}));
export var AncillaryFetchOfferResponseEnum;
(function (AncillaryFetchOfferResponseEnum) {
    AncillaryFetchOfferResponseEnum["SingleTicket"] = "SingleTicket";
    AncillaryFetchOfferResponseEnum["MultiTicketV2"] = "MultiTicketV2";
    AncillaryFetchOfferResponseEnum["MultiCity"] = "MultiCity";
})(AncillaryFetchOfferResponseEnum || (AncillaryFetchOfferResponseEnum = {}));
export var HotelCfarQuotesFailureEnum;
(function (HotelCfarQuotesFailureEnum) {
    HotelCfarQuotesFailureEnum["ShopFailure"] = "ShopFailure";
    HotelCfarQuotesFailureEnum["Unknown"] = "Unknown";
})(HotelCfarQuotesFailureEnum || (HotelCfarQuotesFailureEnum = {}));
export var HotelNoQuoteReasonEnum;
(function (HotelNoQuoteReasonEnum) {
    HotelNoQuoteReasonEnum["DelosDecline"] = "DelosDecline";
    HotelNoQuoteReasonEnum["Unspeciied"] = "Unspeciied";
    HotelNoQuoteReasonEnum["DelosFail"] = "DelosFail";
    HotelNoQuoteReasonEnum["Unexpected"] = "Unexpected";
    HotelNoQuoteReasonEnum["ValidationFailed"] = "ValidationFailed";
})(HotelNoQuoteReasonEnum || (HotelNoQuoteReasonEnum = {}));
export var CfarQuoteResultEnum;
(function (CfarQuoteResultEnum) {
    CfarQuoteResultEnum["HotelCfarQuote"] = "Quote";
    CfarQuoteResultEnum["HotelCfarNoQuote"] = "NoQuote";
})(CfarQuoteResultEnum || (CfarQuoteResultEnum = {}));
export var CfarQuoteEnum;
(function (CfarQuoteEnum) {
    CfarQuoteEnum["HotelCfarNonEligible"] = "NonEligible";
    CfarQuoteEnum["HotelCfarEligible"] = "Eligible";
})(CfarQuoteEnum || (CfarQuoteEnum = {}));
export var GetCfarQuotesResponseEnum;
(function (GetCfarQuotesResponseEnum) {
    GetCfarQuotesResponseEnum["Failure"] = "Failure";
    GetCfarQuotesResponseEnum["Success"] = "Success";
})(GetCfarQuotesResponseEnum || (GetCfarQuotesResponseEnum = {}));
export var FetchCfarOfferResponseV2Enum;
(function (FetchCfarOfferResponseV2Enum) {
    FetchCfarOfferResponseV2Enum["Failure"] = "Failure";
    FetchCfarOfferResponseV2Enum["MultiTicketV2"] = "MultiTicketV2";
    FetchCfarOfferResponseV2Enum["SingleTicket"] = "SingleTicket";
})(FetchCfarOfferResponseV2Enum || (FetchCfarOfferResponseV2Enum = {}));
export var CfarOfferFailureEnum;
(function (CfarOfferFailureEnum) {
    CfarOfferFailureEnum["FareNotFound"] = "FareNotFound";
    CfarOfferFailureEnum["TripNotFound"] = "TripNotFound";
    CfarOfferFailureEnum["Unknown"] = "Unknown";
})(CfarOfferFailureEnum || (CfarOfferFailureEnum = {}));
export var CfarEligibilityResponseEnum;
(function (CfarEligibilityResponseEnum) {
    CfarEligibilityResponseEnum["IsEligible"] = "IsEligible";
    CfarEligibilityResponseEnum["NotEligible"] = "NotEligible";
    CfarEligibilityResponseEnum["Failure"] = "Failure";
})(CfarEligibilityResponseEnum || (CfarEligibilityResponseEnum = {}));
export var CancellationFareRulesResponseEnum;
(function (CancellationFareRulesResponseEnum) {
    CancellationFareRulesResponseEnum["Failure"] = "Failure";
    CancellationFareRulesResponseEnum["Success"] = "Success";
})(CancellationFareRulesResponseEnum || (CancellationFareRulesResponseEnum = {}));
export var CfarEnum;
(function (CfarEnum) {
    CfarEnum["AirlineFullRefund"] = "AirlineFullRefund";
    CfarEnum["AirlinePartialRefundOrCfarCash"] = "AirlinePartialRefundOrCfarCash";
    CfarEnum["CfarCash"] = "CfarCash";
    CfarEnum["CfarCashOrCfarFtc"] = "CfarCashOrCfarFtc";
    CfarEnum["CfarCashOrCfarFtcWithPenalty"] = "CfarCashOrCfarFtcWithPenalty";
    CfarEnum["ContactCustomerService"] = "ContactCustomerService";
    CfarEnum["TicketedVoid"] = "TicketedVoid";
    CfarEnum["TooCloseToDeparture"] = "TooCloseToDeparture";
    /*
      note: CancellationPending isn't a case that's defined in Tysons; it's converted from a CancellationPending scenario
      that is independent of whether it's Cfar or NonCfar. It's added so that the FE can easily extend the current switch statement.
    */
    CfarEnum["CancellationPending"] = "CancellationPending";
    CfarEnum["HtsCfarExercise"] = "HtsCfarExercise";
})(CfarEnum || (CfarEnum = {}));
export var RebookSummaryResponseEnum;
(function (RebookSummaryResponseEnum) {
    RebookSummaryResponseEnum["RebookSummarySuccess"] = "RebookSummarySuccess";
    RebookSummaryResponseEnum["RebookSummaryFailure"] = "RebookSummaryFailure";
})(RebookSummaryResponseEnum || (RebookSummaryResponseEnum = {}));
export var RebookSummaryTripType;
(function (RebookSummaryTripType) {
    RebookSummaryTripType["ROUND_TRIP"] = "round_trip";
    RebookSummaryTripType["ONE_WAY"] = "one_way";
})(RebookSummaryTripType || (RebookSummaryTripType = {}));
export var RebookSummaryFailureEnum;
(function (RebookSummaryFailureEnum) {
    RebookSummaryFailureEnum["ItineraryNotFound"] = "ItineraryNotFound";
    RebookSummaryFailureEnum["ContractNotFound"] = "ContractNotFound";
    RebookSummaryFailureEnum["MissingCoverageOrFareClass"] = "MissingCoverageOrFareClass";
    RebookSummaryFailureEnum["InvalidRoute"] = "InvalidRoute";
    RebookSummaryFailureEnum["ShopSummaryFailed"] = "ShopSummaryFailed";
    RebookSummaryFailureEnum["Unknown"] = "Unknown";
    RebookSummaryFailureEnum["RebookNotEligible"] = "RebookNotEligible";
})(RebookSummaryFailureEnum || (RebookSummaryFailureEnum = {}));
export var PriceDropSmokeEligibilityEnum;
(function (PriceDropSmokeEligibilityEnum) {
    PriceDropSmokeEligibilityEnum["PriceDropEligible"] = "Eligible";
    PriceDropSmokeEligibilityEnum["PriceDropNonEligible"] = "NonEligible";
})(PriceDropSmokeEligibilityEnum || (PriceDropSmokeEligibilityEnum = {}));
export var DisruptionOfferType;
(function (DisruptionOfferType) {
    DisruptionOfferType["Legacy"] = "Legacy";
    DisruptionOfferType["Hts"] = "Hts";
})(DisruptionOfferType || (DisruptionOfferType = {}));
//# sourceMappingURL=ancillaries.js.map